import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="py-24 bg-brand-navy text-white text-center relative overflow-hidden" data-id="element-52">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-53"></div>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-54">
        <h2 className="text-3xl md:text-5xl font-display font-bold mb-6" data-id="element-55">
          ¿Listo Para Transformar Tu Mentalidad?
        </h2>
        <p className="text-xl text-gray-300 mb-10" data-id="element-56">
          No dejes pasar esta colección masiva. El precio volverá a $49.99 USD
          pronto.
        </p>

        <a href="https://pay.hotmart.com/M105206217F?off=j41mgt7g&bid=1780960886484" target="_blank" rel="noopener noreferrer" className="inline-flex justify-center items-center px-10 py-5 text-xl font-bold rounded-xl text-white bg-brand-orange hover:bg-orange-600 transition-all transform hover:scale-105 shadow-[0_0_30px_rgba(249,115,22,0.5)]" data-id="element-57">
          Obtener el Mega Pack por $3.99 USD
        </a>
      </div>
    </section>;
}